/** cinematics module entry (owner: story-builder). */
import { CinematicPlayer, type CinematicHost, type CinematicPlayerOptions } from './CinematicPlayer';

export { TIMELINES, registerTimelines, getTimeline } from './registry';
export { CinematicPlayer, MAX_NESTING } from './CinematicPlayer';
export type { CinematicHost, CinematicCamera, CinematicPlayerOptions, PlayOptions, CinematicResult } from './CinematicPlayer';
export { createSceneCinematicHost, stateFromContext, replayMemoryState } from './SceneHost';
export type { SceneHostDeps, CinematicStateAccess } from './SceneHost';
export { MemoryStage, runMemoryStage, registerMemoryStages, isMemoryStageRunning, MEMORY_STAGES, MEMORY_STAGE_STYLES, MEMORY_DONE } from './MemoryStage';
export type { MemoryStageDef, MemoryStageData, MemoryStageStyle, RunMemoryStageOptions } from './MemoryStage';

export function createCinematicPlayer(host: CinematicHost, opts: CinematicPlayerOptions = {}): CinematicPlayer {
  return new CinematicPlayer(host, opts);
}
